<template>
  <mdb-container fluid>
    <material-card title="Einstellungen" card-icon="cog">
      <template v-slot:content>
        <div class="mt-2">
          <validation-observer ref="form">
            <form novalidate @submit.prevent="save">
              <validation-provider
                name="Zimmer"
                rules="required"
                v-slot="{ errors, valid, validated }"
                slim
              >
                <mdb-select
                  outline
                  v-model="roomsDetails"
                  name="Zimmer"
                  ref="rooms"
                  class="d-inline-flex w-80 mr-2"
                  wrapperClass="mt-0 mb-0 w-100"
                  placeholder="Zimmer auswählen"
                  :customValidation="validated"
                  :isValid="valid"
                  :invalidFeedback="errors[0]"
                  validFeedback="sieht gut aus"
                  :validation="true"
                  @getValue="selectValue"
                />
              </validation-provider>
              <mdb-btn color="primary" size="md" :disabled="loading" type="submit">
                <template v-if="!loading">
                  Erstellen <mdb-icon icon="save" class="ml-1" />
                </template>
                <template v-else>
                  <span
                    class="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Verladung
                </template>
              </mdb-btn>
            </form>
          </validation-observer>
        </div>
      </template>
    </material-card>
  </mdb-container>
</template>

<script>
import { mdbContainer, mdbBtn, mdbIcon, mdbSelect } from "mdbvue";
const MaterialCard = () => import("@/components/card/MaterialCard");
import utils from "@/mixins/Utils";

export default {
  name: "Settings",
  mixins: [utils()],
  components: {
    mdbContainer,
    mdbBtn,
    mdbIcon,
    mdbSelect,
    MaterialCard
  },

  data() {
    return {
      roomsDetails: [],
      rooms: [],
      loading: false,
      selectedRoom: null
    };
  },

  created() {
    this.loadRooms()
  },

  methods: {
    loadRooms() {
      this.$http.get("Dashboard").then(res => {
        this.roomsDetails = []
        this.rooms = res.data.data
        this.rooms.forEach(room => {
          this.roomsDetails.push({
            'text': room.Zimmer,
            'value': room.Id,
            'selected': false
          })
        })
        this.loadSelectedRoom()
      })
    },

    loadSelectedRoom () {
      let settingsRoom = localStorage.getItem('settingsRoom')
      this.roomsDetails.find(room => {
        if (room.value == settingsRoom) {
          room.selected = true
        } else {
          room.selected = false
        }
      })
    },

    selectValue(value) {
      if (value) {
        this.selectedRoom = value
      }
    },

    save () {
      this.$refs.rooms.validate()
      if(this.$refs.rooms.inputValue == null || this.$refs.rooms.inputValue == ""){
        this.loading = false
        return
      }

      this.$refs.form.validate().then(success => {
        this.loading = true
        if (!success) {
          this.loading = false
          return
        }

        let room = null
        this.rooms.forEach(data => {
          if (data.Id === this.selectedRoom) {
            room = data
          }
        })

        localStorage.setItem('room', JSON.stringify(room))
        localStorage.setItem('roomID', room.Id)
        localStorage.setItem('settingsRoom', room.Id)

        let data = localStorage.getItem('room')
        if (data) {
          this.$notify.success({message: 'Einstellungen erstellen erfolgreich', position: 'top right', closeButton: false, timeOut: 5000})
        } else {
          this.$notify.error({message: 'Fehlgeschlagen Einstellung erstellen!!', position: 'top right', closeButton: false, timeOut: 5000})
        }
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
};
</script>
